export const SIDEBAR_WIDTH = 240;
export const SIDEBAR_HEADER_HEIGHT = 56;

/** Vertical offset applied while the white-label test-mode banner is shown. */
export const TEST_MODE_OFFSET = 40;

/** Title shown in the sidebar header for Zeal-branded contexts. */
export const ZEAL_BRAND_TITLE = "Zeal";

/**
 * Path prefix shared by every Zeal-internal route (`/internal`,
 * `/internal-members`, `/internal-tools`, `/internal-reports`,
 * `/internal-taxes`, ...). Internal guests use the same routes. On these pages
 * the header always shows Zeal branding instead of the host's white-label logo.
 */
export const INTERNAL_ROUTE_PREFIX = "/internal";
